import {
  Box,
  Button,
  Flex,
  Icon,
  Show,
  Text,
  useToast,
} from '@chakra-ui/react';
import ModalHeader from '@components/presentational/CustomModal/ModalHeader';
import React, { useMemo, useState } from 'react';
import ModalBody from '@components/presentational/CustomModal/ModalBody';
import Modal from '@components/presentational/CustomModal/Modal';
import { PiCaretRight } from 'react-icons/pi';
import NewsForm from '@components/app/NewsForm';
import { Publication } from '@/types/core/Publication';
import { News } from '@/types/core/News';
import PedagogicalResourceForm from '@components/app/PedagogicalResourceForm';
import { PedagogicalResource } from '@/types/core/PedagogicalResource';

interface SelectOnMobilePublishModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmitEnd?: () => void;
  publication?: Publication;
}
export function SelectOnMobilePublishModal({
  isOpen = false,
  onClose,
  onSubmitEnd,
  publication,
}: SelectOnMobilePublishModalProps) {
  const [showPublish, setShowPublish] = useState<string | null>(null);

  const toast = useToast();

  const [step, setStep] = useState(null);

  const title = useMemo(() => {
    switch (step) {
      case 2:
        return 'Qualifiez votre ressource pour lui donner plus de visibilité';
      case 3:
        return 'Donner de la visibilité à votre ressource';
      default:
        return 'Ma ressource';
    }
  }, [step]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setShowPublish(null);
        onClose();
      }}
      accentColor="tournesol"
      size={['full', 'xl']}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        {showPublish === null && (
          <Show breakpoint="(max-width: 767px)">
            <Flex direction="column" gap="0.5rem">
              <Button
                size="sm"
                variant="sunflowerOutline"
                width="100%"
                onClick={() => setShowPublish('news')}
              >
                <Flex width="100%" justify="space-between" align="center">
                  <Text as="span">Information</Text>
                  <Icon as={PiCaretRight} boxSize="1.5rem" />
                </Flex>
              </Button>
              <Button
                size="sm"
                variant="sunflowerOutline"
                width="100%"
                onClick={() => setShowPublish('pedagogicalResource')}
              >
                <Flex width="100%" justify="space-between" align="center">
                  <Text as="span">Ressource</Text>
                  <Icon as={PiCaretRight} boxSize="1.5rem" />
                </Flex>
              </Button>
            </Flex>
          </Show>
        )}
        {showPublish === 'news' && (
          <NewsForm news={publication as News} onSubmitEnd={onSubmitEnd} />
        )}
        {showPublish === 'pedagogicalResource' && (
          <PedagogicalResourceForm
            resource={publication as PedagogicalResource}
            onSubmitEnd={onSubmitEnd}
            onChangeStep={step => setStep(step)}
          />
        )}
      </ModalBody>
    </Modal>
  );
}
